import { computed, inject, InjectionToken } from '@angular/core';
import { Result } from '@causality/core';
import { FormMetadata } from '@formunauts/shared/campaigning/domain';
import {
  patchState,
  signalStore,
  withComputed,
  withMethods,
  withState,
} from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import * as O from 'effect/Option';
import { pipe, switchMap, tap } from 'rxjs';
import {
  FormMetadataRepository,
  GetCampaignFormsMetadata,
} from './form-meta-repository.model';
import {
  getCampaignFormsMetadata,
  getSCOFormsMetadata,
} from './form-meta.use-case';

interface FormsMetadataStoreState {
  campaign: O.Option<FormMetadata>;
  selfCheckout: O.Option<FormMetadata>;
}

export const CAMPAIGN_FORMS_META_PARAMS =
  new InjectionToken<GetCampaignFormsMetadata>('CAMPAIGN_FORMS_META_PARAMS');

export const FormsMetadataStore = signalStore(
  withState<FormsMetadataStoreState>(() => ({
    campaign: O.none(),
    selfCheckout: O.none(),
  })),
  withMethods(
    (
      store,
      repo = inject(FormMetadataRepository),
      _getCampaign = getCampaignFormsMetadata(repo),
      _getSco = getSCOFormsMetadata(repo),
    ) => ({
      getCampaign: rxMethod<GetCampaignFormsMetadata>(
        pipe(
          switchMap(({ form_id, form_type }) =>
            _getCampaign(form_id, form_type).pipe(
              tap((result) => {
                if (Result.isSuccess(result)) {
                  patchState(store, { campaign: O.some(result.right) });
                }
              }),
            ),
          ),
        ),
      ),
      getSco: rxMethod<string>(
        pipe(
          switchMap((hash) =>
            _getSco(hash).pipe(
              tap((result) => {
                if (Result.isSuccess(result)) {
                  patchState(store, { selfCheckout: O.some(result.right) });
                }
              }),
            ),
          ),
        ),
      ),
    }),
  ),
  withComputed((store) => ({
    campaignMetadata: computed(() => store.campaign()),
    selfCheckoutMetadata: computed(() => store.selfCheckout()),
  })),
);
